export const Sections = {
  PARTICIPATION_BUDGET: 'participation_budget',
  PLANNED_DOCUMENTS: 'planned_documents',
  GEOPRODUCTS: 'geoproducts',
} as const;

export type HeaderSectionType = typeof Sections[keyof typeof Sections];
